import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import type { Settings, SettingsUpdate } from '../lib/database.types'

const SETTINGS_KEY = ['settings']

export function useSettings() {
  return useQuery({
    queryKey: SETTINGS_KEY,
    queryFn: async (): Promise<Settings> => {
      const { data, error } = await supabase.from('settings').select('*').single()
      if (error) throw error
      return data
    },
  })
}

export function useUpdateSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (updates: SettingsUpdate): Promise<Settings> => {
      const { data: existing, error: readErr } = await supabase
        .from('settings')
        .select('id')
        .single()
      if (readErr) throw readErr

      const { data, error } = await supabase
        .from('settings')
        .update(updates)
        .eq('id', existing.id)
        .select('*')
        .single()
      if (error) throw error
      return data
    },
    onSuccess: (data) => {
      queryClient.setQueryData(SETTINGS_KEY, data)
    },
  })
}
